import { Component, OnInit, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { InputFile } from '../model/model';
import { TokenMaquinaModel } from '../model/cadastra-maquina.model';
import { FingerPrintService } from '../services/fingerprint.service';

@Component({
  selector: 'app-modal-recupera-token-usuario',
  templateUrl: './modal-recupera-token-usuario.component.html',
  styleUrls: ['./modal-recupera-token-usuario.component.css']
})
export class ModalRecuperaTokenUsuarioComponent implements OnInit {
  inscricao;
  arquivo;
  possuiErro: boolean;
  mensagemErro;
  tokenModel: TokenMaquinaModel;

  constructor(
    public dialogRef: MatDialogRef<ModalRecuperaTokenUsuarioComponent>,
    private fingerPrintService: FingerPrintService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.inscricao = this.data.inscricao;
    this.possuiErro = false;
  }

  async onChangeFile(event) {
    this.possuiErro = false;
    const inputFile = event.target;
    this.arquivo = new InputFile();
    this.arquivo.nome = inputFile.files[0].name;
    this.arquivo.fileList = {... event.target.files};
    
    this.arquivo.extensaoValida = this.extensaoArquivoValido();
    await this.validarArquivo(event);
   
  }

  async validarArquivo(event) {
    this.mensagemErro = '';
    const conteudo = await this.lerArquivo(event.target.files.item(0));
    this.tokenModel = JSON.parse(conteudo.toString());
    if (this.inscricao !== this.tokenModel.key || !this.tokenModel.jwt) {
      this.mensagemErro = 'Arquivo inválido, por favor exclua';
      this.possuiErro = true;
     }
  }

  lerArquivo(arquivo) {
    return new Promise((resolve, reject) => {
      if (arquivo !== undefined) {
        const fileReader = new FileReader();
        fileReader.onload = function (e) {
          const txt = e.target['result'];
          resolve(txt);
        };
        fileReader.readAsText(arquivo);
      } else {
        reject('Arquivo não é valido');
      }
    });
  }

  aparecerBtEnviar(): boolean {
    return this.arquivo && this.arquivo.nome && !this.possuiErro;
  }
  private armazenarToken(tokenFull) {
    if (tokenFull) {
      this.fingerPrintService.armazenaToken(tokenFull);
    }
  }

  excluirArquivo() {
    this.arquivo = new InputFile();
    this.mensagemErro = null;
    this.possuiErro = false;
  }
   extensaoArquivoValido(): boolean {
    const nomeSplit = this.arquivo.nome.toString().split('.');
    const fileExtension = nomeSplit[1].toUpperCase();
    if (fileExtension !== 'TXT') {
      this.possuiErro = true;
      return false;
    }
    return true;
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onYesClick() {
    this.armazenarToken(JSON.stringify(this.tokenModel));
    this.dialogRef.close();
  }

}
